import { render } from "./GmailMailViewer.vue?vue&type=template&id=15977fa8"
import script from "./GmailMailViewer.vue?vue&type=script&lang=js"
export * from "./GmailMailViewer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__